import permission from './Permission';
import { hasPermission } from './hasPermission';
import { useProfile } from './useProfile';
import { useClaims, useRefreshClaims } from './useClaims';
import AuthorizationApiProvider from './AuthorizationApiProvider';

export type { FlattenedPermissions } from './types';
export { authorizationProviderSymbol } from './AuthorizationProvider';

export { useProfile, useClaims, hasPermission, useRefreshClaims };

export const getAuthorizationProvider = () => {
  return AuthorizationApiProvider;
};

export { permission };
